import React, { useEffect, useState } from 'react';
import styles from './Table.module.css';

const TableHeader = ({
  parent,
  columns,
  checkBox,
  action,
  selectData,
  tableContainerRef,
  isFixed,
  check,
  scrollLeft,
  scrollLeftInside,
  topScroll,
  mini,
  noGap,
  scroll,
  width,
  stickyHeader,
  isHeaderFixed,
  tableWrapperWidth,
  componentName,
  tableBodyWidth,
}) => {
  const cellBaseStyle = {
    borderRight: '1px solid #E8E8E8',
    height: 'inherit !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px',
  };

  return (
    <thead
      className={`${styles.thead} ${
        isFixed || isHeaderFixed ? styles.fix : ''
      }`}
      style={{
        top: stickyHeader ? 'unset' : scroll ? topScroll : '65px',
        // top: scroll ? topScroll + 150 : topScroll,
        // left: scrollLeft === 'unset' ? 'unset' : -scrollLeft,
        // height: isFixed ? (mini ? '32px' : '60px') : '42px',
        height: '42px',
        marginBottom: noGap ? 0 : '8px',
        border:
          parent === 'addContainerAutobook' ? 'none' : '1px solid #E8E8E8',
        borderBottom: '1px solid #E8E8E8',
        boxShadow: noGap
          ? 'none'
          : '0px 2px 4px -2px rgba(24, 39, 75, 0.12),0px 4px 4px -2px rgba(24, 39, 75, 0.08)',
        display: 'flex',
        width:
          componentName === 'YourAppointments' && !isFixed ? 'auto' : width,
      }}>
      <tr
        style={{
          display: 'flex',
          // width: width || 'auto',
          // overflow: 'auto',
          width: componentName === 'YourAppointments' && tableBodyWidth,
          position:
            componentName === 'YourAppointments' && isFixed
              ? 'absolute'
              : 'relative',
          left:
            componentName === 'preApproveContainers'
              ? -scrollLeftInside
              : isFixed || isHeaderFixed
              ? scrollLeft === 'unset' || scrollLeftInside === 'unset'
                ? 'unset'
                : -scrollLeft || -scrollLeftInside
              : 'unset',
        }}>
        {check && <th style={{ width: '38px', ...cellBaseStyle }}>Action</th>}

        {columns.map((col) => (
          <th
            key={col.field}
            style={{
              ...(col.width
                ? { width: col.width }
                : col.flex
                ? { flex: col.flex || 1 }
                : {}),
              ...cellBaseStyle,
              textAlign: col.align || 'center', // Alignment of text
            }}>
            {col.label || col.title}
          </th>
        ))}
        {checkBox && <th style={{ width: '50px' }}>{checkBox}</th>}
        {action && !check && (
          <th
            style={{
              flex: 2.2,
              minWidth: '70px',
              width: `${action?.length * 70}px`,
            }}>
            Action
          </th>
        )}
      </tr>
    </thead>
  );
};

export default TableHeader;
